// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2NUKa","footer":"ModalUpdate_footer__3PNQd"};